import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { langRoutes, ScrollToTop } from "@/routes";
import { initAnalytics } from "@/lib/analytics";

initAnalytics();

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Toaster position="top-center" richColors />
      <Routes>
        <Route path="/en">{langRoutes("en")}</Route>
        <Route path="/">{langRoutes("id")}</Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
